import { Box, createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { SortFields, SortOrder } from 'model/Service';
import React, { FunctionComponent, useState } from 'react';
import TableHeaderItem from './TableHeaderItem';
import clsx from 'clsx';

interface Props {
    onSort: (field: SortFields, order: SortOrder) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            width: '100%'
        },
        rowContainer: {
            display: 'flex',
            width: '100%',
            fontWeight: 600,
            fontSize: 16,
            borderBottom: '2px solid #000000',
            paddingBottom: 17
        },
        leftSpace: {
            [theme.breakpoints.down('lg')]: {
                paddingLeft: 24
            },
            [theme.breakpoints.up('xl')]: {
                paddingLeft: 32
            }
        },
        rightSpace: {
            [theme.breakpoints.down('lg')]: {
                marginLeft: '-15px'
            },
            [theme.breakpoints.up('xl')]: {
                marginLeft: '-20px'
            }
        },
        headerInactive: {
            [theme.breakpoints.down('lg')]: {
                paddingLeft: 75
            },
            [theme.breakpoints.up('lg')]: {
                paddingLeft: 50
            }
        },
        leftSpaceServices: {
            [theme.breakpoints.down('lg')]: {
                paddingLeft: 45
            },
            [theme.breakpoints.up('xl')]: {
                paddingLeft: 60
            }
        },
        hideOnMobile: {
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },
        staffContainer: {
            width: '17%'
        },
        serviceName: {
            width: '30%'
        },
        durationContainer: {
            width: '17%'
        },
        priceContainer: {
            width: '18%'
        },
        taxesContainer: {
            width: '10%'
        }
    })
);

export const ServicesHeaderList: FunctionComponent<Props> = props => {
    const classes = useStyles();

    const [sortField, setSortField] = useState<SortFields | undefined>(undefined);
    const [sortOrder, setSortOrder] = useState<SortOrder | undefined>(undefined);

    const sortHandler = (field: SortFields, order: SortOrder) => {
        setSortField(field);
        setSortOrder(order);
        props.onSort(field, order);
    };

    return (
        <Box className={clsx(classes.container, classes.hideOnMobile)}>
            <Box className={classes.rowContainer}>
                <Box className={classes.headerInactive}></Box>
                <Box className={classes.serviceName}>
                    <TableHeaderItem
                        label="Name"
                        sortField={SortFields.NAME}
                        sortOrder={sortField === SortFields.NAME ? sortOrder : undefined}
                        onSort={sortHandler}
                    />
                </Box>
                <Box className={clsx(classes.hideOnMobile, classes.staffContainer)}>Staff</Box>
                <Box className={clsx(classes.hideOnMobile, classes.durationContainer)}>Duration</Box>
                <Box className={clsx(classes.hideOnMobile, classes.priceContainer)}>Price</Box>
                <Box className={clsx(classes.hideOnMobile, classes.taxesContainer)}>Taxes</Box>
            </Box>
        </Box>
    );
};
